<ng-template #inline>
	<ng-container *transloco="let t;read:'radioList'">
		<div class="radio-list-container"
			 [class.input-container-pristine]="(control.pristine && !control.disabled)  || (control.valid && !(control?.value))"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="control.valid && control.value">
			<h4 *transloco="let t; read: 'journal'">{{label}} <ng-container *ngTemplateOutlet="warn"></ng-container></h4>
			<div class="d-flex flex-wrap">
				<div class="c-mb-1" *ngFor="let item of options; let i = index">
					<form-radio
						[label]="translationPrefix ? t(translationPrefix + item) : item"
						[control]="formArray.at(i)"
						[value]="options[i]"
						[name]="name"
						(change)="setValue(i)"
						[markAsWarning]="item === warningOption"
						class="mr-4"
						[id]="idArr[i]">
					</form-radio>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="!control.pristine && control.errors">
		<ng-container *ngTemplateOutlet="errors"></ng-container>
	</ng-container>
</ng-template>

<ng-template #warn>
	<ng-container *transloco="let t; read: 'journal'">
		<ng-container *ngIf="warningsArray?.length">
			(<ng-container *ngFor="let warning of warningsArray; let last = last, let first = first">
				<span *ngIf="warning"
					  [ngbTooltip]="t('warnings.'+warning)"
					  container="body">{{t('generic.'+warning)}}<ng-container *ngIf="!last">, </ng-container></span>
			</ng-container>)
		</ng-container>
	</ng-container>
</ng-template>

<ng-template #notInline>
	<div class="radio-list-container row align-items-center m-0"
		 *transloco="let t;read:'radioList'"
		 [class.input-container-pristine]="(control.pristine && !control.disabled)  || (control.valid && !(control?.value))"
		 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
		 [class.input-container-valid]="control.valid && control.value">
		<div class="col-3" *ngIf="template === ControlTemplate.horizontal">
			<div class="row m-0 p-0 h-100 align-content-center">
				<h4 class="m-0"
					*transloco="let t; read: 'journal'">{{label}} <ng-container *ngTemplateOutlet="warn"></ng-container>
				</h4>
			</div>
		</div>
		<div class="input-group shadow-none p-0"
			[ngClass]="{
			     'col-9': template === ControlTemplate.horizontal,
			     'col-12': template === ControlTemplate.vertical
			     }">
			<div class="col-12 p-0" *ngIf="template === ControlTemplate.vertical">
				<h4 *transloco="let t; read: 'journal'">{{label}} <ng-container *ngTemplateOutlet="warn"></ng-container></h4>
			</div>
			<div *ngIf="formArray"
				 class="list-group list-group-flush"
				 [class.variant-vertical]="variant === ControlTemplate.vertical"
				 [class.variant-horizontal]="variant === ControlTemplate.horizontal">
				<div class="list-group-element" *ngFor="let item of options; let i = index">
					<form-radio
						[label]="translationPrefix ? t(translationPrefix + item) : item"
						[control]="formArray.at(i)"
						[name]="name"
						[value]="options[i]"
						(change)="setValue(i)"
						[markAsWarning]="item === warningOption"
						[id]="idArr[i]">
					</form-radio>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #errors>
	<div class="control-errors-wrapper">
		<div class="control-errors col-12 pl-0" *ngFor="let error of control.errors | keyvalue">
			<span class="error">{{error.value}}</span>
		</div>
	</div>
</ng-template>

<ng-container>
	<div [ngSwitch]="template" class="form-control-container">
		<ng-container *ngSwitchCase="ControlTemplate.horizontal">
			<ng-container *ngTemplateOutlet="notInline"></ng-container>
			<ng-container *ngIf="!control.pristine && control.errors">
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.vertical">
			<ng-container *ngTemplateOutlet="notInline"></ng-container>
			<ng-container *ngIf="!control.pristine && control.errors">
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inline">
			<ng-container *ngTemplateOutlet="inline"></ng-container>
		</ng-container>
	</div>
</ng-container>
